import React, { Component } from 'react';
import MappedUserList from './MappedUserList';

class MappedUserListContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fromDashboard: (props.location && props.location.state && props.location.state.fromDashboard === true),
            refreshUserList: '',
            loading: false,
            newUserName: '',
            searchString: '',
            searchSubmit: '',
        }
    }

    componentDidMount() {

    }

    /** 
     * 	@description Function to handle search submit
     *  @param searchString The value in the input field
     *  @memberof UserListContainer
     */
    handleSearchSubmit = (searchString) => {
        this.setState({ searchString: searchString, searchSubmit: true, refreshUserList: '' });
    }

    /** 
     *  @description Function to handle search reset
     *  @memberof UserListContainer
     */
    handleReset = () => {
        if(!this.state.searchString) {
            return
        }
        this.setState({ searchString: '', searchSubmit: '', refreshUserList: '' });
    }

    /** 
     *  @description Function to handle user updated after creation
     *  @memberof UserListContainer
     */
    mappedUserUpdated = (status, username = '') => {
        this.setState({ refreshUserList: status, newUserName: username });
    }

    /** 
     *  @description Function to handle user status updated after creation
     *  @memberof UserListContainer
     */
    userStatusUpdated = (status) => {
        this.setState({ refreshUserList: status, searchSubmit: true });
    }

    /** 
     *  @description Function to toggle loader from sub components
     *  @memberof UserListContainer
     */
    toggleLoader = (status) => {
        this.setState({ loading: status, refreshUserList: false, searchSubmit: false });
    }

    render() {
        return (
            <MappedUserList
                refreshUserList={this.state.refreshUserList}
                loading={this.state.loading}
                toggleLoader={this.toggleLoader}
                searchString={this.state.searchString}
                searchSubmit={this.state.searchSubmit}
                handleSearchSubmit={this.handleSearchSubmit}
                handleReset={this.handleReset}
                mappedUserUpdated={this.mappedUserUpdated}
                userStatusUpdated={this.userStatusUpdated}
                newUserName={this.state.newUserName}
                fromDashboard={this.state.fromDashboard}
            />
        );
    }
}

export default MappedUserListContainer;
